import { getChannel, getDocument, getPlaceId } from '@lib/server';
import { APIImageType, Place } from '@types';

import { SearchContext } from '../../util/search-context';
import { PostGridClient } from './client';

export interface SearchPost {
  brandPosts: string[];
  categories: string[];
  excerpt: string;
  id: string;
  image: APIImageType[];
  preserveAspectRatio: boolean;
  publishedDate: number;
  slug: string;
  title: string;
  venuePosts: string[];
}

export async function PostGrid({ params, id }: { params: { domain: string; venue?: string }; id?: string }) {
  const channel = await getChannel(decodeURIComponent(params.domain));
  const aggregatorId = channel?.micrositeData?.[0]?.id;

  if (!aggregatorId) return null;

  const { placeId } = params.venue ? await getPlaceId(channel, decodeURIComponent(params.venue)) : {};
  const place = placeId
    ? await getDocument<Place>('place', placeId, {
        select: ['fields.default', 'fields.name'],
        tags: [channel.channelId],
        depth: 0,
      })
    : undefined;

  return (
    <SearchContext
      contentForm="blogPosts"
      configure={{
        hitsPerPage: 36,
        filters: placeId ? `venuePosts:=:${placeId}` : `brandPosts:=:${aggregatorId}`,
      }}
    >
      <PostGridClient id={id} params={params} place={place?.fields} />
    </SearchContext>
  );
}
